import type { NavigateFunction } from 'react-router-dom';
import type { AppTranslations } from 'translations/translations';
import type { ShowNotificationCommand } from 'utils/hooks/useNotifications';
import type { ApiRequestFunction } from 'utils/request/useApi';
import type { TestValues } from '../TestForm';
import { buildWebhookDeliveriesLink } from '../constants';

export interface TestWebHookCommand {
  values: TestValues;
}

export const makeTestWebHook =
  (
    apiRequest: ApiRequestFunction,
    msg: AppTranslations,
    showNotification: (command: ShowNotificationCommand) => void,
    navigate: NavigateFunction,
  ) =>
  async ({
    values: { id, name, type, action, status },
  }: TestWebHookCommand): Promise<void> => {
    await apiRequest({
      url: `/webhooks/${id}/test/${type}/${action}`,
      method: 'POST',
      data: status ? { status } : {},
    });

    const makeHandleClick = (handleClose: () => void) => () => {
      navigate(buildWebhookDeliveriesLink(name));
      handleClose();
    };

    showNotification({
      type: 'info',
      message: msg.settings.webHooks.request.test(makeHandleClick),
    });
  };
